import actionsTypes from '../constants/ActionsTypes';

const INITIAL_STATE = {
    socket: null,
    teacher: null,
    student: null,
    connectedUsers: 0,
    connectionInternet: null,
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case actionsTypes.SET_SOCKET:
            return {
                ...state,
                socket: action.socket
            };
        case actionsTypes.SET_TEACHER:
            return {
                ...state,
                teacher: action.teacher
            };
        case actionsTypes.SET_STUDENT:
            return {
                ...state,
                student: action.student
            };
        case actionsTypes.SET_CONNECTED_USERS:
            return {
                ...state,
                connectedUsers: action.connectedUsers
            };
        case actionsTypes.SET_CONNECTION_INTERNET:
            return {
                ...state,
                connectionInternet: action.connectionInternet
            };

        default:
            return state;
    }
}
